import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createBlock(_component_v_row, {
    class: _normalizeClass(_ctx.isVertical ? 'h-screen' : 'w-100'),
    align: "center",
    justify: "center"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_progress_circular, {
        size: _ctx.progressSize,
        width: _ctx.progressWidth,
        color: "primary",
        indeterminate: ""
      }, null, 8, ["size", "width"])
    ]),
    _: 1
  }, 8, ["class"]))
}